import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { DamageReportStep } from '../../models';
import { CreateDamageReportService } from '../../create-damage-report.service';
import { ReactiveFormsModule } from '@angular/forms';
import { CtrlAutoresizeTextareaDirective, CtrlDateInputDirective } from '@co-3/ctrl-ui/forms';
import { RequiredInfoComponent } from 'app/shared/components/required-info/required-info.component';
import { PortalActionButtonsComponent } from '../../../components/portal-action-buttons/portal-action-buttons.component';
import { DamageReportStepHeaderComponent } from '../../components/damage-report-step-header/damage-report-step-header.component';

@Component({
    selector: 'app-damage-date-and-location-form-step',
    imports: [
        ReactiveFormsModule,
        CtrlDateInputDirective,
        CtrlAutoresizeTextareaDirective,
        RequiredInfoComponent,
        PortalActionButtonsComponent,
        DamageReportStepHeaderComponent,
    ],
    templateUrl: './damage-date-and-location-form-step.component.html',
    styleUrl: './damage-date-and-location-form-step.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DamageDateAndLocationFormStepComponent implements DamageReportStep {
    protected form = inject(CreateDamageReportService).reportForm;

    @Output()
    public onPrev = new EventEmitter<void>();

    @Output()
    public onNext = new EventEmitter<void>();

    @Output()
    public onCancel = new EventEmitter<void>();

    @Input()
    public isFirst = false;

    protected canGoToNextStep(): boolean {
        return this.form.controls.damageDate.valid && this.form.controls.location.valid;
    }
}
